export const TRENDS = [
    {
      header: "Gaming.Trending",
      name: "#VALORANTChampions",
      number: "27.9K posts",
    },
    {
      header: "",
      name: "الانستا",
      number: "1,411 posts",
    },
    {
      header: "Gaming.Trending",
      name: "Mako",
      number: "14.1K posts",
    },
    {
      header: "",
      name: "رسالة_اليوم#",
      number: "22.3K posts",
    },
    {
      header: "",
      name: "#Messi",
      number: "77.2K posts",
    },
    {
      header: "",
      name: "جامعة_طبية#",
      number: "",
    },
    {
      header: "",
      name: "ايفون",
      number: "27.6K posts",
    },
    {
      header: "Gaming.Trending",
      name: "fnatic",
      number: "8,748 posts",
    },
    {
      header: "",
      name: "الاعلام العبري",
      number: "",
    },
    {
      header: "Gaming.Trending",
      name: "#InterMiamiCF",
      number: "68.14 posts",
    },
  ];